<!--
 * @Author: guoyu
 * @Date: 2021-04-20 11:16:59
 * @LastEditors: your name
 * @LastEditTime: 2021-04-27 17:05:58
 * @Description: 簽約用戶邀請新人统计页
-->
<template>
    <div class="invite-page">
      <div
        class="invite-button"
        v-clipboard="inviteLink"
        @click="shareLink"
      ></div>
      <section class="info-block desc-block">
        <h3 class="info-title"><i class="title-tag"></i>活動規則</h3>
        <p class="invit-desc">
          邀請新用戶註冊，可獲得該用戶1個月內消費金額的10%返利喔。每個自然月邀請用戶量到達合約數額還有額外bonus獎勵喔～
        </p>
      </section>
      <section class="info-block">
        <h3 class="info-title"><i class="title-tag"></i>邀請成就</h3>
        <InviteInfo :inviteInfo="refInfo"></InviteInfo>
        <div class="split-line" v-show="listTotal"></div>
        <h3 class="info-title" v-show="listTotal">
          <i class="title-tag"></i>邀請記錄
        </h3>
        <InviteList v-model="listTotal" v-show="listTotal"></InviteList>
      </section>
    </div>
</template>
<script>
import InviteInfo from './components/invite-info';
import InviteList from './components/invite-list';
export default {
  components: {
    InviteInfo,
    InviteList
  },
  data() {
    return {
      refInfo: {}, // 邀请相关数据
      listTotal: 0 // 是否有邀请
    };
  },
  computed: {
    inviteLink() {
      const host =
        process.env.VUE_APP_ENV !== 'production'
          ? 'https://dev.nicee.tw'
          : 'https://www.nicee.tw';
      return `${host}/invite/${this.refInfo.uniqueCode}`;
    }
  },
  methods: {
    getRefInfo() {
      this.$http
        .get('/signUp/info')
        .then(({ data }) => {
          this.refInfo = data || {};
        })
        .catch(e => {
          console.error(e);
        });
    },
    shareLink() {
      this.$message.success('專屬連結已複製');
    }
  },
  created() {
    this.getRefInfo();
  }
};
</script>
<style lang="scss" scoped>
.invite-page {
  width: 980px;
  padding: 449px 178px 112px;
  margin-top: 24px;
  background-color: #d32942;
  background-image: url(./images/first-page.jpg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center top;
  /deep/ .header-hold {
    display: none;
  }
  /deep/ .header-wrap {
    padding: 0 !important;
  }
}
.invite-button {
  position: absolute;
  width: 300px;
  height: 80px;
  top: 324px;
  left: 50%;
  transform: translateX(-50%);
  background: url(./images/share-button.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.info-block {
  padding: 20px 16px;
  margin-bottom: 16px;
  background: #fff5f7;
  border-radius: 10px;
}
.info-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 20px;
  font-size: 14px;
  color: #2d041e;
}
.title-tag {
  display: block;
  width: 4px;
  height: 12px;
  margin-right: 6px;
  background: #d32942;
}
.invit-desc {
  margin-top: 5px;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  color: #44072e80;
}
.split-line {
  height: 1px;
  margin-bottom: 16px;
  background: #f9e7e7;
}
</style>
